import type { HighlightTextProps } from './JsonViewer.helpers';

const HighlightText = ({ text, highlight }: HighlightTextProps) => {
	if (!highlight) return <>{text}</>;
	const regex = new RegExp(`(${highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
	const parts = text.split(regex);
	return (
		<>
			{parts.map((part, index) =>
				part.toLowerCase() === highlight.toLowerCase() ? <mark key={`${part}-${index}`}>{part}</mark> : part
			)}
		</>
	);
};

export default HighlightText;
